<template>
  <div class="container" style="padding-top: 5rem">
    <div class="account-box">
      <!-- LOGIN FORM -->
      <div class="account-wrapper">
        <h3 class="account-title">Benefits Connect<br />v.21112025</h3>
        <hr />
        <form @submit.prevent="login">
          <div
            role="alert"
            class="alert alert-success"
            v-if="forgotPasswordSuccess || changePasswordSuccess"
          >
            <div class="row align-items-center">
              <div class="col-2">
                <i class="fa fa-check-circle fa-2x"></i>
              </div>
              <div class="col-10 pl-0">
                <template v-if="forgotPasswordSuccess"
                  >If the email account exists, a link is sent to the email
                  address to reset your password</template
                >
                <template v-if="changePasswordSuccess"
                  >Your password has been reset. Please login below with your
                  new password.</template
                >
              </div>
            </div>
          </div>
          <p class="text-danger text-center" v-if="errorMessage">
            {{ errorMessage }}
          </p>
          <div class="form-group">
            <label>Login Name</label>
            <input
              class="form-control"
              type="text"
              v-model="loginName"
              maxlength="100"
              required
            />
          </div>
          <div class="form-group">
            <label>Password</label>
            <input
              class="form-control"
              type="password"
              v-model="password"
              maxlength="50"
              required
            />
          </div>
          <div class="form-group text-center">
            <button class="btn btn-primary account-btn" type="submit">
              Login
            </button>
          </div>
          <div style="display: none" class="form-group text-center mb-1">
            <router-link
              :to="{
                name: 'forgotPassword',
              }"
            >
              Forgot password?
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      errorMessage: "",
      loginName: "",
      password: "",
      enableInsuranceModule: config.ENABLE_INSURANCE_MODULE,
      enableAttendanceModule: config.ENABLE_ATTENDANCE_MODULE,
      enableCarParkModule: config.ENABLE_CAR_PARK_MODULE,
      enableCorporatePassModule: config.ENABLE_CORPORATE_PASS_MODULE,
    };
  },
  computed: {
    forgotPasswordSuccess() {
      return this.$store.state.forgotPasswordSuccess;
    },
    changePasswordSuccess() {
      return this.$store.state.changePasswordSuccess;
    },
  },
  created() {
    let isSSO = localStorage.getItem("lamsso");

    if (isSSO == "true") {
      this.$router.replace({ name: "sso", query: { session: "expired" } });
    }
  },
  methods: {
    login() {
      this.errorMessage = "";
      this.$store.state.forgotPasswordSuccess = false;
      this.$store.state.changePasswordSuccess = false;
      this.$store.state.isLoading = true;
      API.login({ LoginName: this.loginName, Password: this.password })
        .then((response) => {
          this.$store.state.isLoading = false;
          let success = response.data.success;
          if (success) {
            let data = response.data.data;
            localStorage.setItem("lambitoken", JSON.stringify(data));
            localStorage.setItem("lamsso", false);
            this.redirectToPage(data);
          } else {
            this.errorMessage = response.data.message;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
          this.errorMessage = error;
        });
    },
    redirectToPage(data) {
      if (data.Role == "admin") {
        window.location = "/group";
      } else {
        let param = {
          Token: data.Token,
          Company: data.Company,
        };
        API.getMenus(param)
          .then((response) => {
            this.$store.state.isLoading = false;
            if (response.data.success) {
              let menus = response.data.record;
              if (
                menus.find(
                  (c) =>
                    c.Children[0].Name == "Dashboard" &&
                    c.Children[0].Selected == true
                ) != null &&
                (data.IsManager ||
                  data.IsNextManager ||
                  data.HasCarparkClaimDelegation ||
                  data.HasTimesheetDelegation)
              ) {
                window.location = "/dashboard";
              } else {
                let hasMyBenefitOptionsAccess = false;
                let parent = menus.find((c) => c.Parent == "Benefit");
                if (parent) {
                  let child = parent.Children.find(
                    (c) => c.Name == "My Benefit Options" && c.Selected == true
                  );
                  if (child) hasMyBenefitOptionsAccess = true;
                }
                if (hasMyBenefitOptionsAccess) {
                  window.location = "/employeebenefitoption";
                } else {
                  for (let menu of menus) {
                    for (let child of menu.Children) {
                      if (child.Selected == true) {
                        let name = child.Name;
                        if (name == "My Insurance and Dependents") {
                          window.location = "/insurancedependent";
                          return;
                        } else if (name == "My Timesheet") {
                          window.location = "/attendance/timesheet";
                          return;
                        } else if (name == "My Monthly Overtime Report") {
                          window.location =
                            "/attendance/report/timesheet/mymonthlyovertime";
                          return;
                        } else if (
                          name ==
                          "My Monthly Overtime, Standby & Shift Allowance Report"
                        ) {
                          window.location =
                            "/attendance/report/timesheet/mymonthlyotstandbyshiftallowance";
                          return;
                        } else if (
                          name == "My Staff Timesheet List" &&
                          data.IsManager
                        ) {
                          window.location = "/attendance/list/timesheet";
                          return;
                        } else if (
                          name == "My Staff Monthly Overtime Report" &&
                          data.IsManager
                        ) {
                          window.location =
                            "/attendance/report/timesheet/monthlyovertime";
                          return;
                        } else if (
                          name ==
                            "My Staff Monthly Overtime, Standby & Shift Allowance Report" &&
                          data.IsManager
                        ) {
                          window.location =
                            "/attendance/report/timesheet/monthlyotstandbyshiftallowance";
                          return;
                        } else if (name == "My Car Park Claim") {
                          window.location = "/carpark/myclaim";
                          return;
                        } else if (name == "View Car Park Claim") {
                          window.location = "/carpark/viewclaims";
                          return;
                        } else if (
                          name == "My Staff Car Park Claim" &&
                          data.IsManager
                        ) {
                          window.location = "/carpark/mystaffcarparkclaim";
                          return;
                        } else if (
                          name == "My Staff Monthly Car Park Claim Report" &&
                          data.IsManager
                        ) {
                          window.location = "/carpark/monthlyclaimreport";
                          return;
                        } else if (name == "Submit Corporate Pass") {
                          window.location = "/corppass/submit";
                          return;
                        } else if (name == "My Booking History") {
                          window.location = "/corppass/bookinghistory";
                          return;
                        } else if (name == "My Leave of Absence") {
                          window.location = "/leave/myleave";
                          return;
                        } else if (name == "My Leave of Absence Report") {
                          window.location = "/leave/myleavereport";
                          return;
                        } else if (
                          name == "My Staff Leave of Absence" &&
                          data.IsManager
                        ) {
                          window.location = "/leave/mystaffleave";
                          return;
                        } else if (
                          name == "My Staff Leave of Absence Report" &&
                          data.IsManager
                        ) {
                          window.location = "/leave/mystaffleavereport";
                          return;
                        } else if (name == "My FWA") {
                          window.location = "/fwa/form";
                          return;
                        } else if (name == "My FWA Record") {
                          window.location = "/fwa/my-fwa-record";
                          return;
                        } else if (
                          name == "My Staff FWA Record" &&
                          (data.IsManager || data.IsNextManager)
                        ) {
                          window.location = "/fwa/my-staff-fwa-record";
                          return;
                        } else if (
                          name == "My Staff FWA Report" &&
                          (data.IsManager || data.IsNextManager)
                        ) {
                          window.location = "/fwa/report";
                          return;
                        } else if (name == "Delegation" && data.IsManager) {
                          window.location = "/delegation";
                          return;
                        }
                      }
                    }
                  }
                  window.location = "/home";
                }
              }
            } else {
              this.$swal(response.data.message, { icon: "error" });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Account/Login.vue